export const UNLOCK_ERROR_CONTENT = Object.freeze({
  invalid: {
    title: 'Invalid invite link',
    message: "This link isn't recognized. Ask the person who sent it for a new one.",
  },
  expired: {
    title: 'Invite expired',
    message: 'This invite has expired. Ask the person who sent it for a new one.',
  },
  revoked: {
    title: 'Invite revoked',
    message: 'This invite has been revoked. Ask the person who sent it for a new one.',
  },
  device_limit: {
    title: 'Device limit reached',
    message: 'This invite has reached its device limit. Ask the person who sent it for another link.',
  },
  already_active: {
    title: 'Already signed in',
    message: 'This browser is already signed in with another invite. Log out first if you want to switch.',
  },
})

export function getUnlockErrorContent(code) {
  return UNLOCK_ERROR_CONTENT[code] || UNLOCK_ERROR_CONTENT.invalid
}

// Mirrors server/auth/sanitize.js compactSecret. Strips ASCII whitespace,
// non-breaking spaces, zero-width chars (ZWSP/ZWNJ/ZWJ), Unicode bidi
// controls (LRM/RLM/LRO/RLO/PDF), line/paragraph separators, word joiner,
// and BOM. Without this, paste from Slack / Gmail / certain terminals
// can silently corrupt the token even though everything looks normal.
const INVISIBLE_RE = new RegExp(
  '[\\s\\u200B-\\u200F\\u2028-\\u202F\\u2060-\\u2064\\uFEFF]',
  'g'
)

export function sanitizeUnlockCodeInput(value) {
  if (typeof value !== 'string') return ''
  return value.replace(INVISIBLE_RE, '')
}

// Pull the raw `putio_…` token out of whatever the user typed: just the token,
// or an invite URL like https://host/unlock/putio_abc, or the path /unlock/...
// Mirrors server/auth/routes.js extractUnlockToken. Used by LockedView so a
// device_limit response can route the user to /unlock/<token>/devices for
// self-service even when they pasted a full URL.
export function extractUnlockTokenFromInput(value) {
  const compact = sanitizeUnlockCodeInput(value)
  if (!compact) return null
  if (
    compact.startsWith('http://') ||
    compact.startsWith('https://') ||
    compact.startsWith('/') ||
    compact.includes('/unlock/')
  ) {
    const match = compact.match(/(?:\/|^)unlock\/([^/?#]+)/i)
    if (!match || !match[1]) return null
    try {
      return decodeURIComponent(match[1])
    } catch {
      return null
    }
  }
  return compact
}
